const Routes = {
  API: {
    STORAGE: {
      UPLOAD: '/api/storage/upload'
    },
    CONTENT: {
      TREE: '/api/content/tree',
      GEO: {
        AIRPORTS: '/api/content/geo/airports',
        LOCATION: '/api/content/geo/location',
        ROUTE: {
          SEARCH: '/api/content/geo/route/search',
          UPDATE: '/api/content/geo/route/update',
        }
      },
      TRANSLATE: '/api/content/translate',
      OBJECTS: {
        LIST: '/api/content/objects'
      }
    },
    DEV: {
      GEOIP: '/api/dev/geo-ip'
    }
  }
};

module.exports = Routes;